import Vue from 'vue';

import VueImg from 'v-img';

Vue.use(VueImg);

import App from './App.vue';

import router from './router';
// Custom store-like facility
import Store from '@/pf-store.js';
Vue.use(Store);
import Utils from '@/pf-utils.js';
Vue.use(Utils, { logPrefix: 'PFWEB' });
import './registerServiceWorker';
import SvgIcon from 'vue-svgicon';
Vue.use(SvgIcon, {
  isOriginalDefault: true
});
import vueSmoothScroll from 'vue-smoothscroll';
Vue.use(vueSmoothScroll);
import Affix from 'vue-affix';
import './assets/tailwind.css';
Vue.use(Affix);
// Google font (local)
require('typeface-roboto');

Vue.config.productionTip = false;

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app');
